<template>
  <div class="Exhibition subWrapper">
    <!-- logo + menu -->
    <LogoMenu :loadmounted="ismobile" />
    <!-- 内容 -->
    <div class="sub_contBox" v-if="!ismobile">
      <div class="contbox_scroll">
        <div class="contbox_top">
          <!-- 我要参展 txt -->
          <div class="sub_title"><img src="../assets/image/right_arrow.png" /><span>我要参展</span><img src="../assets/image/left_arrow.png" /></div>
          <!-- 内容 -->
          <div class="Exhibition_cont sub_cont">
            <p class="MsoNormal" style="text-align: center;font-size: 18px;"><b>2021中国（上海）国际隧道工程研讨会</b></p>
            <p class="MsoNormal" style="text-align: center;font-size: 18px;"><b>赞助方案</b></p>
            <p class="MsoNormal" align="center" style="text-align:center;text-indent:28.0pt;">
            	&nbsp;
            </p>
            <p class="MsoNormal" style="text-indent:24.0pt;">
            	在轨道交通飞速发展和城市超大直径公路隧道蓬勃兴起的大背景下，定于<b><span>2021</span>年<span>4</span>月<span>18~20</span>日在上海浦东香格里拉大酒店（富城路<span>33</span>号）举办“<span>2021</span>中国（上海）国际隧道工程研讨会”</b>，共同探讨隧道设计、建设、运营管理等方面面临的难题与技术创新，迎接新挑战。<span></span>
            </p>
            <p class="MsoNormal" style="text-indent:24.0pt;">
            	为了把本次大会办得更好，大会组委会诚挚地邀请行业同仁共同参与推进相关工作，“<span>2021</span>中国（上海）国际隧道工程研讨会”是一个国际性的展示平台，为相关企业提供不同类别的展示方案，供各企业展示其企业、产品、技术、优势等。如果您有兴趣成为我们的合作伙伴，欢迎来电来函。<span></span>
            </p>
            <p class="MsoNormal" style="text-indent:24.0pt;">
            	&nbsp;
            </p>
            <p class="MsoNormal" style="color:rgb(255,0,0);text-align: center;">
            	<b>隧道行业尖峰会议，一个您不能错过的展示机会！<span></span></b>
            </p>
            <p class="MsoNormal" style="text-indent:24.0pt;">
            	&nbsp;
            </p>
            <p class="MsoNormal" style="color:rgb(0,112,192);font-size: 16px;text-align: center;">
            	<b>铂金协办商（<span>30</span>万）</b>
            </p>
            <p class="Default" style="padding-left: 12pt;position: relative;">
            	<span style="position: absolute;top: 0;left: 0;color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span style="mso-list:Ignore;">·</span></span>单位全名以协办单位的名义体现在大会背景板上；<span></span>
            </p>
            <p class="Default" style="padding-left: 12pt;position: relative;">
            	<span style="position: absolute;top: 0;left: 0;color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span style="mso-list:Ignore;">·</span></span>单位全名以协办单位的名义出现在会议手册等会议资料上；<span></span>
            </p>
            <p class="Default" style="padding-left: 12pt;position: relative;">
            	<span style="position: absolute;top: 0;left: 0;color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span style="mso-list:Ignore;">·</span></span>可在大会手册上免费刊登企业彩色广告和文字介绍；<span></span>
            </p>
            <p class="Default" style="padding-left: 12pt;position: relative;">
            	<span style="position: absolute;top: 0;left: 0;color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span style="mso-list:Ignore;">·</span></span>享有<span> 1 </span>个主题报告展示机会；<span></span>
            </p>
            <p class="Default" style="padding-left: 12pt;position: relative;">
            	<span style="position: absolute;top: 0;left: 0;color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span style="mso-list:Ignore;">·</span></span>享有<span> 1 </span>个<span>VIP</span>嘉宾席位；<span></span>
            </p>
            <p class="Default" style="padding-left: 12pt;position: relative;">
            	<span style="position: absolute;top: 0;left: 0;color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span style="mso-list:Ignore;">·</span></span>享有 <span>6 </span>个免费参会名额；<span></span>
            </p>
            <p class="Default" style="padding-left: 12pt;position: relative;">
            	<span style="position: absolute;top: 0;left: 0;color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span style="mso-list:Ignore;">·</span></span>主办方对其客户进行定向邀请，并享有优惠折扣；<span></span>
            </p>
            <p class="Default" style="padding-left: 12pt;position: relative;">
            	<span style="position: absolute;top: 0;left: 0;color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span style="mso-list:Ignore;">·</span></span>可在会议资料袋内放入企业宣传资料；<span></span>
            </p>
            <p class="Default" style="padding-left: 12pt;position: relative;">
            	<span style="position: absolute;top: 0;left: 0;color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span style="mso-list:Ignore;">·</span></span>享有开会期间主办方提供的免费展示区域；<span></span>
            </p>
            <p class="Default" style="padding-left: 12pt;position: relative;">
            	<span style="position: absolute;top: 0;left: 0;color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span style="mso-list:Ignore;">·</span></span>享有大会官网及微信公众号为其企业提供的相关宣传服务；<span></span>
            </p>
            <p class="Default" style="padding-left: 12pt;position: relative;">
            	<span style="position: absolute;top: 0;left: 0;color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span style="mso-list:Ignore;">·</span></span>会后享有主办方提供的会议相关资料。<span></span>
            </p>
            <p style="padding-left: 12pt;"><a name="_MON_1673242258" href="/doc/300k.docx" style="color: #2468f2;margin-top: 10px;">如有需求请点击下载协议</a></p>
            <p class="Default" style="margin-left:35.0pt;">&nbsp;
            </p>
            <p class="MsoNormal">
            	<b>&nbsp;</b>
            </p>
            <p class="MsoNormal" style="color:rgb(0,112,192);font-size: 16px;text-align: center;">
            	<b>金牌协办商（<span>20</span>万）</b>
            </p>
            <p class="Default" style="padding-left: 12pt;position: relative;">
            	<span style="position: absolute;top: 0;left: 0;color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span style="mso-list:Ignore;">·</span></span>单位全名以协办单位的名义体现在大会背景板上；<span></span>
            </p>
            <p class="Default" style="padding-left: 12pt;position: relative;">
            	<span style="position: absolute;top: 0;left: 0;color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span style="mso-list:Ignore;">·</span></span>单位全名以协办单位的名义出现在会议手册等会议资料上；<span></span>
            </p>
            <p class="Default" style="padding-left: 12pt;position: relative;">
            	<span style="position: absolute;top: 0;left: 0;color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span style="mso-list:Ignore;">·</span></span>可在大会手册上免费刊登企业彩色广告和文字介绍；<span></span>
            </p>
            <p class="Default" style="padding-left: 12pt;position: relative;">
            	<span style="position: absolute;top: 0;left: 0;color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span style="mso-list:Ignore;">·</span></span>享有<span> 1 </span>个主题报告展示机会；<span></span>
            </p>
            <p class="Default" style="padding-left: 12pt;position: relative;">
            	<span style="position: absolute;top: 0;left: 0;color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span style="mso-list:Ignore;">·</span></span>享有<span> 1 </span>个<span>VIP</span>嘉宾席位；<span></span>
            </p>
            <p class="Default" style="padding-left: 12pt;position: relative;">
            	<span style="position: absolute;top: 0;left: 0;color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span style="mso-list:Ignore;">·</span></span>享有<span> 4 </span>个免费参会名额；<span></span>
            </p>
            <p class="Default" style="padding-left: 12pt;position: relative;">
            	<span style="position: absolute;top: 0;left: 0;color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span style="mso-list:Ignore;">·</span></span>主办方对其客户进行定向邀请，并享有优惠折扣；<span></span>
            </p>
            <p class="Default" style="padding-left: 12pt;position: relative;">
            	<span style="position: absolute;top: 0;left: 0;color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span style="mso-list:Ignore;">·</span></span>可在会议资料袋内放入企业宣传资料；<span></span>
            </p>
            <p class="Default" style="padding-left: 12pt;position: relative;">
            	<span style="position: absolute;top: 0;left: 0;color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span style="mso-list:Ignore;">·</span></span>享有开会期间主办方提供的免费展示区域；<span></span>
            </p>
            <p class="Default" style="padding-left: 12pt;position: relative;">
            	<span style="position: absolute;top: 0;left: 0;color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span style="mso-list:Ignore;">·</span></span>享有大会官网及微信公众号为其企业提供的相关宣传服务；<span></span>
            </p>
            <p class="Default" style="padding-left: 12pt;position: relative;">
            	<span style="position: absolute;top: 0;left: 0;color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span style="mso-list:Ignore;">·</span></span>会后享有主办方提供的会议相关资料。<span></span>
            </p>
            <p style="padding-left: 12pt;"><a name="_MON_1673242258" href="/doc/200k.docx" style="color: #2468f2;margin-top: 10px;">如有需求请点击下载协议</a></p>
            <p class="Default" style="text-indent:28.0pt;">
            	&nbsp;
            </p>
            <p class="MsoNormal" style="color:rgb(0,112,192);font-size: 16px;text-align: center;">
            	<b>银牌协办商（<span>10</span>万）</b>
            </p>
            <p class="Default" style="padding-left: 12pt;position: relative;">
            	<span style="position: absolute;top: 0;left: 0;color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span style="mso-list:Ignore;">·</span></span>单位全名以协办单位的名义体现在大会背景板上；<span></span>
            </p>
            <p class="Default" style="padding-left: 12pt;position: relative;">
            	<span style="position: absolute;top: 0;left: 0;color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span style="mso-list:Ignore;">·</span></span>单位全名以协办单位的名义出现在会议手册等会议资料上；<span></span>
            </p>
            <p class="Default" style="padding-left: 12pt;position: relative;">
            	<span style="position: absolute;top: 0;left: 0;color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span style="mso-list:Ignore;">·</span></span>可在大会手册上免费刊登企业彩色广告和文字介绍；<span></span>
            </p>
            <p class="Default" style="padding-left: 12pt;position: relative;">
            	<span style="position: absolute;top: 0;left: 0;color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span style="mso-list:Ignore;">·</span></span>享有<span> 1 </span>个<span>VIP</span>嘉宾席位；<span></span>
            </p>
            <p class="Default" style="padding-left: 12pt;position: relative;">
            	<span style="position: absolute;top: 0;left: 0;color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span style="mso-list:Ignore;">·</span></span>享有<span> 2 </span>个免费参会名额；<span></span>
            </p>
            <p class="Default" style="padding-left: 12pt;position: relative;">
            	<span style="position: absolute;top: 0;left: 0;color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span style="mso-list:Ignore;">·</span></span>享有现场展板展示机会，由主办方制作；<span></span>
            </p>
            <p class="Default" style="padding-left: 12pt;position: relative;">
            	<span style="position: absolute;top: 0;left: 0;color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span style="mso-list:Ignore;">·</span></span>主办方对其客户进行定向邀请，并享有优惠折扣；<span></span>
            </p>
            <p class="Default" style="padding-left: 12pt;position: relative;">
            	<span style="position: absolute;top: 0;left: 0;color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span style="mso-list:Ignore;">·</span></span>享有大会官网及微信公众号为其企业提供的相关宣传服务；<span></span>
            </p>
            <p class="Default" style="padding-left: 12pt;position: relative;">
            	<span style="position: absolute;top: 0;left: 0;color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span style="mso-list:Ignore;">·</span></span>会后享有主办方提供的会议相关资料。<span></span>
            </p>
            <p style="padding-left: 12pt;"><a name="_MON_1673242258" href="/doc/100k.docx" style="color: #2468f2;margin-top: 10px;">如有需求请点击下载协议</a></p>
            <p class="Default" style="margin-left:35.0pt;">
            	<b>&nbsp;</b>&nbsp;
            </p>
            <p class="MsoNormalCxSpMiddle">
            	<b>联系人：</b>
            </p>
            <p class="MsoNormalCxSpMiddle" style="text-indent:20.1pt;">王桂华：<span>021-64225589 13166298002&nbsp;&nbsp; </span></p>
            <p class="MsoNormalCxSpMiddle" style="text-indent:20.1pt;">邮箱：<span><a href="mailto:2021CITS@tunnelling.cn">2021CITS@tunnelling.cn</a></span></p>
          </div>
        </div>
        <!-- 底部信息 -->
        <Foot />
      </div>
    </div>
    <!-- pc -->
    <div class="sub_contBox" v-else>
      <!-- 面包屑 -->
      <div class="Breadcrumb_box">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>我要参展</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- 主体 -->
      <div class="content_box">
        <div class="content_txt">
          <p class="MsoNormal" style="text-align: center;font-size: 24px;">
          	<b>2021</b><b>中国（上海）国际隧道工程研讨会赞助方案</b><b></b>
          </p>
          <p class="MsoNormal" align="center" style="text-align:center;text-indent:28.0pt;">
          	&nbsp;
          </p>
          <p class="MsoNormal" style="text-indent:24.0pt;">
          	在轨道交通飞速发展和城市超大直径公路隧道蓬勃兴起的大背景下，定于<b><span>2021</span>年<span>4</span>月<span>18~20</span>日在上海浦东香格里拉大酒店（富城路<span>33</span>号）举办“<span>2021</span>中国（上海）国际隧道工程研讨会”</b>，共同探讨隧道设计、建设、运营管理等方面面临的难题与技术创新，迎接新挑战。<span></span>
          </p>
          <p class="MsoNormal" style="text-indent:24.0pt;">
          	为了把本次大会办得更好，大会组委会诚挚地邀请行业同仁共同参与推进相关工作，“<span>2021</span>中国（上海）国际隧道工程研讨会”是一个国际性的展示平台，为相关企业提供不同类别的展示方案，供各企业展示其企业、产品、技术、优势等。如果您有兴趣成为我们的合作伙伴，欢迎来电来函。<span></span>
          </p>
          <p class="MsoNormal" style="text-indent:24.0pt;">
          	&nbsp;
          </p>
          <p class="MsoNormal" style="color:rgb(255,0,0);text-align: center;">
          	<b>隧道行业尖峰会议，一个您不能错过的展示机会！<span></span></b>
          </p>
          <p class="MsoNormal" style="text-indent:24.0pt;">
          	&nbsp;
          </p>
          <p class="MsoNormal" style="color:rgb(0,112,192);font-size: 16px;">
          	<b>铂金协办商（<span>30</span>万）</b>
          </p>
          <p class="Default" style="margin-left:49.0pt;text-indent:-21.0pt;">
          	<span style="color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span>·</span></span>&nbsp; 单位全名以协办单位的名义体现在大会背景板上；<span></span>
          </p>
          <p class="Default" style="margin-left:49.0pt;text-indent:-21.0pt;">
          	<span style="color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span>·</span></span>&nbsp; 单位全名以协办单位的名义出现在会议手册等会议资料上；<span></span>
          </p>
          <p class="Default" style="margin-left:49.0pt;text-indent:-21.0pt;">
          	<span style="color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span>·</span></span>&nbsp; 可在大会手册上免费刊登企业彩色广告和文字介绍；<span></span>
          </p>
          <p class="Default" style="margin-left:49.0pt;text-indent:-21.0pt;">
          	<span style="color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span>·</span></span>&nbsp; 享有<span> 1 </span>个主题报告展示机会；<span></span>
          </p>
          <p class="Default" style="margin-left:49.0pt;text-indent:-21.0pt;">
          	<span style="color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span>·</span></span>&nbsp; 享有<span> 1 </span>个<span>VIP</span>嘉宾席位；<span></span>
          </p>
          <p class="Default" style="margin-left:49.0pt;text-indent:-21.0pt;">
          	<span style="color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span>·</span></span>&nbsp; 享有 <span>6 </span>个免费参会名额；<span></span>
          </p>
          <p class="Default" style="margin-left:49.0pt;text-indent:-21.0pt;">
          	<span style="color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span>·</span></span>&nbsp; 主办方对其客户进行定向邀请，并享有优惠折扣；<span></span>
          </p>
          <p class="Default" style="margin-left:49.0pt;text-indent:-21.0pt;">
          	<span style="color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span>·</span></span>&nbsp; 可在会议资料袋内放入企业宣传资料；<span></span>
          </p>
          <p class="Default" style="margin-left:49.0pt;text-indent:-21.0pt;">
          	<span style="color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span>·</span></span>&nbsp; 享有开会期间主办方提供的免费展示区域；<span></span>
          </p>
          <p class="Default" style="margin-left:49.0pt;text-indent:-21.0pt;">
          	<span style="color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span>·</span></span>&nbsp; 享有大会官网及微信公众号为其企业提供的相关宣传服务；<span></span>
          </p>
          <p class="Default" style="margin-left:49.0pt;text-indent:-21.0pt;">
          	<span style="color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span>·</span></span>&nbsp; 会后享有主办方提供的会议相关资料。<span></span>
          </p>
          <p><a name="_MON_1673241262" href="/doc/300k.docx" style="color: #2468f2;margin-top: 10px;">如有需求请点击下载协议</a></p>
          <p class="Default" style="margin-left:49.0pt;">&nbsp;
          </p>
          <p class="MsoNormal">
          	<b>&nbsp;</b>
          </p>
          <p class="MsoNormal" style="color:rgb(0,112,192);font-size: 16px;">
          	<b>金牌协办商（<span>20</span>万）</b>
          </p>
          <p class="Default" style="margin-left:49.0pt;text-indent:-21.0pt;">
          	<span style="color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span>·</span></span>&nbsp; 单位全名以协办单位的名义体现在大会背景板上；<span></span>
          </p>
          <p class="Default" style="margin-left:49.0pt;text-indent:-21.0pt;">
          	<span style="color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span>·</span></span>&nbsp; 单位全名以协办单位的名义出现在会议手册等会议资料上；<span></span>
          </p>
          <p class="Default" style="margin-left:49.0pt;text-indent:-21.0pt;">
          	<span style="color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span>·</span></span>&nbsp; 可在大会手册上免费刊登企业彩色广告和文字介绍；<span></span>
          </p>
          <p class="Default" style="margin-left:49.0pt;text-indent:-21.0pt;">
          	<span style="color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span>·</span></span>&nbsp; 享有<span> 1 </span>个主题报告展示机会；<span></span>
          </p>
          <p class="Default" style="margin-left:49.0pt;text-indent:-21.0pt;">
          	<span style="color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span>·</span></span>&nbsp; 享有<span> 1 </span>个<span>VIP</span>嘉宾席位；<span></span>
          </p>
          <p class="Default" style="margin-left:49.0pt;text-indent:-21.0pt;">
          	<span style="color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span>·</span></span>&nbsp; 享有<span> 4 </span>个免费参会名额；<span></span>
          </p>
          <p class="Default" style="margin-left:49.0pt;text-indent:-21.0pt;">
          	<span style="color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span>·</span></span>&nbsp; 主办方对其客户进行定向邀请，并享有优惠折扣；<span></span>
          </p>
          <p class="Default" style="margin-left:49.0pt;text-indent:-21.0pt;">
          	<span style="color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span>·</span></span>&nbsp; 可在会议资料袋内放入企业宣传资料；<span></span>
          </p>
          <p class="Default" style="margin-left:49.0pt;text-indent:-21.0pt;">
          	<span style="color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span>·</span></span>&nbsp; 享有开会期间主办方提供的免费展示区域；<span></span>
          </p>
          <p class="Default" style="margin-left:49.0pt;text-indent:-21.0pt;">
          	<span style="color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span>·</span></span>&nbsp; 享有大会官网及微信公众号为其企业提供的相关宣传服务；<span></span>
          </p>
          <p class="Default" style="margin-left:49.0pt;text-indent:-21.0pt;">
          	<span style="color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span>·</span></span>&nbsp; 会后享有主办方提供的会议相关资料。<span></span>
          </p>
          <p><a name="_MON_1673242214" href="/doc/200k.docx" style="color: #2468f2;margin-top: 10px;">如有需求请点击下载协议</a></p>
          <p class="Default" style="text-indent:28.0pt;">
          	&nbsp;
          </p>
          <p class="MsoNormal" style="color:rgb(0,112,192);font-size: 16px;">
          	<b>银牌协办商（<span>10</span>万）</b>
          </p>
          <p class="Default" style="margin-left:49.0pt;text-indent:-21.0pt;">
          	<span style="color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span>·</span></span>&nbsp; 单位全名以协办单位的名义体现在大会背景板上；<span></span>
          </p>
          <p class="Default" style="margin-left:49.0pt;text-indent:-21.0pt;">
          	<span style="color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span>·</span></span>&nbsp; 单位全名以协办单位的名义出现在会议手册等会议资料上；<span></span>
          </p>
          <p class="Default" style="margin-left:49.0pt;text-indent:-21.0pt;">
          	<span style="color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span>·</span></span>&nbsp; 可在大会手册上免费刊登企业彩色广告和文字介绍；<span></span>
          </p>
          <p class="Default" style="margin-left:49.0pt;text-indent:-21.0pt;">
          	<span style="color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span>·</span></span>&nbsp; 享有<span> 1 </span>个<span>VIP</span>嘉宾席位；<span></span>
          </p>
          <p class="Default" style="margin-left:49.0pt;text-indent:-21.0pt;">
          	<span style="color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span>·</span></span>&nbsp; 享有<span> 2 </span>个免费参会名额；<span></span>
          </p>
          <p class="Default" style="margin-left:49.0pt;text-indent:-21.0pt;">
          	<span style="color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span>·</span></span>&nbsp; 享有现场展板展示机会，由主办方制作；<span></span>
          </p>
          <p class="Default" style="margin-left:49.0pt;text-indent:-21.0pt;">
          	<span style="color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span>·</span></span>&nbsp; 主办方对其客户进行定向邀请，并享有优惠折扣；<span></span>
          </p>
          <p class="Default" style="margin-left:49.0pt;text-indent:-21.0pt;">
          	<span style="color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span>·</span></span>&nbsp; 享有大会官网及微信公众号为其企业提供的相关宣传服务；<span></span>
          </p>
          <p class="Default" style="margin-left:49.0pt;text-indent:-21.0pt;">
          	<span style="color:rgb(0,0,0);font-size:14.0000pt;font-weight: bold;"><span>·</span></span>&nbsp; 会后享有主办方提供的会议相关资料。<span></span>
          </p>
          <p><a name="_MON_1673242258" href="/doc/100k.docx" style="color: #2468f2;margin-top: 10px;">如有需求请点击下载协议</a></p>
          <p class="Default" style="margin-left:49.0pt;">
          	<b>&nbsp;</b>&nbsp;
          </p>
          <p class="MsoNormalCxSpMiddle" style="text-indent:20.1pt;">
          	<b>联系人：</b>王桂华：<span>021-64225589 13166298002&nbsp;&nbsp; </span>邮箱：<span><a href="mailto:2021CITS@tunnelling.cn">2021CITS@tunnelling.cn</a></span>
          </p>
        </div>
      </div>
    </div>
    <!-- 底部信息 -->
    <Foot v-if="ismobile" />
  </div>
</template>

<script>
  import LogoMenu from '../components/LogoMenu.vue'
  import Foot from '../components/Footer.vue'
  export default {
    name: "Exhibition",
    data() {
      return {
        content: '',
        name: '',
        ismobile: false,
        navList: [],
        activeName: '大会概况',
        menuName: ''
      }
    },
    created() {
      let wid = window.innerWidth;
      if (wid >= 320 && wid <= 1024) {
        this.ismobile = false;
      } else {
        this.ismobile = true;
      }
    },
    methods: {
    },
    components: {
      LogoMenu,
      Foot
    }
  }
</script>

<style scoped>
  @media screen and (min-width: 1029px) {
    .content_txt {
      margin: 0 auto 30px;
    }

    .content_txt p{
      font-size: 16px;
      line-height: 30px;
      color: #333333;
    }
  }
  @media screen and (min-width: 320px) and (max-width: 1024px) {
    .Exhibition_cont p{
      font-size: .28rem;
      line-height: .48rem;
      color: #333333;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Exhibition.vue